module.exports = __webpack_public_path__ + "static/media/title_marquee_PA.293b5ac0.webp";